import {LoginSlice} from "../../redux/loginReducer";
import {AppDispatch} from "../../redux/store";
import {siteOrigin, backendUrl} from "../../globalConfig";

export const logoutUserAsync = () => async (dispatch: AppDispatch) => {
    fetch(backendUrl+'/auth/mail_auth/logout', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': siteOrigin
        }})
        .then(() => dispatch(LoginSlice.actions.redux_logout()))
}